import React from "react";
import styled from "styled-components";
import Helmet from "react-helmet";
import { Paper } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import LoginForm from "../components/LoginForm";
import { ReactComponent as Logo } from "../assets/images/logo.svg";

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)}px;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)}px;
  }
`;

const LogoWrapper = styled("div")`
  margin-bottom: 3rem;
  height: 100px;
`;

function Login() {
  const { t } = useTranslation("common");

  return (
    <div>
      <LogoWrapper>
        <Logo />
      </LogoWrapper>
      <Wrapper>
        <Helmet title={t("Login")} />
        <LoginForm />
      </Wrapper>
    </div>
  );
}

export default Login;
